import Sidebar from "../components/Sidebar";
import { MessageCircle } from "lucide-react";
import MobileHeader from "../components/MobileHeader";
import ProtectDashboardRoute from "../components/ProtectDashboardRoute";

export default function ChatUsPage() {
  return (
    <div className="flex min-h-screen bg-gray-50">
      <ProtectDashboardRoute />
      {/* Sidebar */}
      <Sidebar />
      <MobileHeader />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Header */}

        {/* Page Content */}
        <main className="flex-1 flex items-center justify-center p-8">
          <div className="bg-white rounded-2xl shadow-lg p-10 max-w-md w-full text-center">
            <MessageCircle className="w-16 h-16 text-[#007AFF] mx-auto mb-6" />

            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Need Help?
            </h2>
            <p className="text-gray-600 mb-6">
              Our support team is available on Telegram to assist you with any
              questions or issues.
            </p>

            <a
              href="https://t.me/dottiverify" // 🔗 Replace with your Telegram link
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#007AFF] text-white px-6 py-3 rounded-lg shadow hover:bg-[#005FCC] transition inline-block font-semibold"
            >
              Chat with Support on Telegram
            </a>
          </div>
        </main>
      </div>
    </div>
  );
}
